<button class="search-button" (click)="handleLeadingIconClicked($event)" mat-ripple>
  <ui-icon [faName]="icon()" faStyle="light"></ui-icon>
</button>

<input
  #searchInput
  type="text"
  [disabled]="disabled()"
  (focus)="focused.emit()"
  [formControl]="searchFieldControl"
  [placeholder]="placeholder()"
  [readOnly]="readOnly()"
  [value]="searchFieldControl.value"
  (keydown.enter)="handleKeyDownEnter()">

@if (!readOnly() && searchFieldControl.value.length > 0) {
  <button (click)="handleClearInputClicked()" mat-ripple>
    <ui-icon faName="xmark" faStyle="light"></ui-icon>
  </button>
}

@if (isCapacitorApp()) {
  <button (click)="handleBarcodeClicked($event)" mat-ripple>
    <ui-icon faName="barcode" faStyle="light"></ui-icon>
  </button>
}
